import { render } from "./TheHeader.vue?vue&type=template&id=ed0e1b3a"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=ed0e1b3a&lang=scss"
script.render = render

export default script